module.exports = __webpack_public_path__ + "static/hero_video-a2fde1a6f139fe0bb0f271c9213d8859.mp4";